if(typeof(Bold) === 'undefined') 
  var Bold = {};
Bold.cleanCart = function(cart){
  
  var cart_total = 0;
  for(var item in cart.items){
    /* Check for RO discount. Requires V2 RO to get the discount percentage for Options */
    var discount_multiplier = 100.00;
    if (cart.items[item].properties && cart.items[item].properties._ro_discount_percentage){
      discount_multiplier -= parseFloat(cart.items[item].properties._ro_discount_percentage);
    }
    discount_multiplier *= 0.01;
    
    /* Set the price to match the discounted price, if discount is set */
    if(cart.items[item].properties && cart.items[item].properties._ro_unformatted_price){
      cart.items[item].price = parseInt(cart.items[item].properties._ro_unformatted_price);
      cart.items[item].line_price = cart.items[item].price * cart.items[item].quantity;
    }
    
    if(cart.items[item].properties && ( (cart.items[item].properties._master_builder && cart.items[item].properties._builder_id) || (cart.items[item].properties.master_builder && cart.items[item].properties.builder_id) )){
      var builder_id = '';
      if(cart.items[item].properties._master_builder) builder_id = cart.items[item].properties._builder_id;
      else builder_id = cart.items[item].properties.builder_id;
      cart.items[item].builder_id = builder_id;
      cart.items[item].builder_type = 'bold-master';
      var bold_price = 0;
      for(var priceitem in cart.items){
        if(cart.items[priceitem].properties && (cart.items[priceitem].properties._builder_id == builder_id || cart.items[priceitem].properties.builder_id == builder_id )){
          bold_price += cart.items[priceitem].price;
        }
      }
      
      /* Apply the RO discount (If unset, multiplies by 1.00) */
      cart.items[item].price = Math.ceil(bold_price * discount_multiplier);
      cart.items[item].line_price = bold_price * cart.items[item].quantity;
      
    }
  }
  /*Now that we've found all of the right prices, we can drop the syncronization property fields*/
  for(var item in cart.items){
    if(cart.items[item].properties && ( cart.items[item].properties.builder_id && !cart.items[item].properties.master_builder || cart.items[item].properties._builder_id && !cart.items[item].properties._master_builder) ){
      if(cart.items[item].properties.builder_id) cart.items[item].builder_id = cart.items[item].properties.builder_id;
      else cart.items[item].builder_id = cart.items[item].properties._builder_id;
      
      cart.item_count -= cart.items[item].quantity;
      cart.items[item].builder_type = 'bold-hidden';
      cart.items[item].properties = { bold_hidden: true };
      continue;
    }
    
    
    /* Check for builder_info and set builder properties if found */
    if(cart.items[item].properties && (cart.items[item].properties.builder_info || cart.items[item].properties._builder_info) ){
      var builder_info;
      if(cart.items[item].properties.builder_info) builder_info = cart.items[item].properties.builder_info.split('~~');
      else builder_info = cart.items[item].properties._builder_info.split('~~');
      
      cart.items[item].builder_image_alt = builder_info[0];
      cart.items[item].builder_image_src = builder_info[1];
      cart.items[item].url = builder_info[2];
    }
    
    /* Finally, remove any properties that shouldn't be showing to the customer */
    if(cart.items[item].properties) {
      for(var property in cart.items[item].properties){
        if( (property.slice(0,1) == '_' && property.slice(1,1) !='_' ) || property == 'master_builder' || property == 'builder_id' || property == 'builder_info' || property == 'frequency_type' || property == 'frequency_type_text' || property == 'frequency_num' || property == 'group_id' || property == 'discounted_price' || cart.items[item].properties[property] == ""){
          delete cart.items[item].properties[property];
        }
      }
    }
    
    /* Add the line price to our cart's total for non-hidden products */
    cart_total += cart.items[item].line_price;
  }
  cart.total_price = cart_total;
  return(cart);
};

Bold.updateQtyBoxes = function(){
  jQuery.each(jQuery('.bold-master'), function(i, obj){
    jQuery('.bold-hidden[data-bold-id="' + jQuery(obj).data('bold-id') + '"] [name*="updates"]').val( jQuery(obj).find('[name*="updates"]').val() );
  });
};
Bold.propertiesDisplay = function(properties){
  if(typeof(properties) !== "object")
    return "";
  
  var property_desc = '<div class="bold-properties">';
  for(var key in properties){
    property_desc += '<div class="bold_option_line"><span class="bold_option_title">' + key + '</\span><span class="bold_option_seperator">: </\span><span class="bold_option_value">' + properties[key] + '</\span>';
  }
  property_desc += '</div>';
  return property_desc;
};

//     Bold: Helper for using Quantity Breaks with Quick-Shop
Bold.update_message_quickshop = function(productID){
jQuery("#shappify-qty-msg-" + productID).html(jQuery('[data-product-id="' + productID +'"] #variant_html_' + jQuery('[data-product-id="' + productID +'"] [name="id"]').val()).html());

if(jQuery('[data-product-id="' + productID +'"] [name="id"]:checked').length){
  jQuery("#shappify-qty-msg-" + productID).html(jQuery('[data-product-id="' + productID +'"] #variant_html_' + jQuery("[name='id']:checked").val()).html());
}
  var prds=jQuery(".shapp_qb_prod");
  var i=0;
  for(i=0;i<prds.length;i++){
    var shapp_var_id=jQuery(prds[i]).find("[name='id']").val();
    var shapp_message=jQuery("#variant_html_"+ shapp_var_id).html();
    var shapp_message_container=jQuery(prds[i]).find(".shappify-qty-msg");
    shapp_message_container.html(shapp_message);
  }
}

/*  Shopify API functions that we need but are not guaranteed to pre-exist on the site   */
Bold.getCart = function(t) {
    jQuery.getJSON("/cart.js", function(e, n) {
        "function" == typeof t ? t(Bold.cleanCart(e)) : Shopify.onCartUpdate(Bold.cleanCart(e));
    });
};
Bold.updateCartFromForm = function(t, e) {
    var n = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + t).serialize(),
        dataType: "json",
        success: function(t) {
            "function" == typeof e ? e(Bold.cleanCart(t)) : Shopify.onCartUpdate(Bold.cleanCart(t))
        },
        error: function(t, e) {
            Shopify.onError(t, e)
        }
    };
    jQuery.ajax(n)
}

